import { Button } from '@design-system/components/button/button';
import { Col } from '@design-system/components/grid/grid';
import { faStar } from '@fortawesome/pro-regular-svg-icons';
import { faStar as faStarFull } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButtonProps } from '@mui/material';

export const FavButton = (p: {
  isFav: boolean;
  isLoading?: boolean;

  onClick: IconButtonProps['onClick'];
}) => (
  <Col style={{ width: 50, height: 40 }}>
    <Button
      style={{ width: 50, height: 40 }}
      leftIcon={p.isLoading ? undefined : p.isFav ? faStarFull : faStar}
      loading={p.isLoading}
      variant="text"
      onClick={p.onClick}
    />
  </Col>
);

export const FavIcon = (p: { full?: boolean; className?: string }) => (
  <FontAwesomeIcon
    icon={p.full ? faStarFull : faStar}
    className={p.className}
  />
);
